import {z} from 'zod';

export const PaidGigsCountersSchema = z.object({
  invites: z.number().int(),
  pending: z.number().int(),
  active: z.number().int(),
  completed: z.number().int(),
});

export const PaidGigsCountersResponseSchema = z.object({
  data: PaidGigsCountersSchema,
  jsonapi: z
    .object({
      version: z.string(),
    })
    .passthrough()
    .optional(),
});

export type PaidGigsCounters = z.infer<typeof PaidGigsCountersSchema>;
export type PaidGigsCountersResponse = z.infer<
  typeof PaidGigsCountersResponseSchema
>;
